import { FolderOutlined } from "@ant-design/icons";
import { Button, Col, Input, Row, Space, Form, Tooltip } from "antd";
import { useEffect, useState } from "react";
import {
  ContainerData,
  RequestDataQuery,
  emptyRequestDataProperties as emptyData,
} from "../../../../api/data-types";

import "./search-types.css";
import { FolderModal } from "../../../layout/folder-modal/folder-modal";
import { FolderPatternParams } from "../../util/data-types/data-types-search-page";

interface FolderPatternSearchProps {
  theme: string;
  sendDataComponent: (
    container: ContainerData,
    offset: number,
    prevOffset: number,
    limit: number,
    folderPattern?: string,
    fileName?: string
  ) => Promise<void>;
  limit: number;
  selectedContainer: ContainerData;
  folderFromUrl: FolderPatternParams;
}

export const FolderPatternSearch = ({
  theme,
  sendDataComponent,
  limit,
  selectedContainer,
  folderFromUrl,
}: FolderPatternSearchProps) => {
  const [form] = Form.useForm<FormData>();

  const [loading, setLoading] = useState<boolean>(false);

  const [openFolderModal, setOpenFolderModal] = useState<boolean>(false);

  const [folderPath, setFolderPath] = useState<string>("");

  const [disabled, setDisabled] = useState<boolean>(true);

  const onFinish = async (values: any) => {
    setLoading(true);
    await sendDataComponent(
      selectedContainer,
      Number(emptyData.EMPTY_OFFSET),
      Number(emptyData.EMPTY_OFFSET),
      limit,
      values.folder ? (values.folder as string) : undefined,
      values.fileName ? (values.fileName as string) : undefined
    );
    setLoading(false);
  };

  const updateFolderValue = (aPath: string, updatePath: boolean) => {
    setOpenFolderModal(false);
    if (updatePath) {
      setFolderPath(aPath);
    }
  };

  const checkDisabled = () => {
    if (!form.getFieldValue("folder") && !form.getFieldValue("fileName")) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }

  const onValuesChange = () => {
    checkDisabled();
  };

  useEffect(() => {
    form.setFieldValue("folder", folderPath);
    checkDisabled();
  }, [folderPath]);

  useEffect(() => {
    form.setFieldValue("folder", folderFromUrl.folderPattern);
    form.setFieldValue("fileName", folderFromUrl.fileName);
    checkDisabled();
  }, [folderFromUrl]);

  const textColor = theme === "light" ? "#000000" : "#ffffff";

  return (
    <Form form={form} onFinish={onFinish}>
      <div>
        <Col span={24}>
          <Row gutter={10} align="top" style={{ marginTop: "10px" }}>
            <Col span={4} className="textOnPageColumn">
              File Name
            </Col>
            <Col span={8}>
              <Form.Item name="fileName">
                <Input
                  style={{ color: textColor }}
                  placeholder="filename.*"
                  onChange={onValuesChange}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col span={4} className="textOnPageColumn" style={{}}>
              Folder Name
            </Col>
            <Col span={8} style={{ textAlign: "right" }}>
              <Form.Item name="folder">
                <Input
                  style={{ color: textColor }}
                  placeholder="ELN1234/*"
                  onChange={onValuesChange}
                />
              </Form.Item>
            </Col>
            <Col span={1}>
              <Tooltip
                title={
                  selectedContainer.containerName === ""
                    ? "Select container to enable folder choosing"
                    : ""
                }
              >
                <Button
                  className="folderButton"
                  icon={<FolderOutlined />}
                  onClick={() => {
                    setOpenFolderModal(true);
                  }}
                  disabled={selectedContainer.containerName === ""}
                />
                <FolderModal
                  theme={theme}
                  isOpen={openFolderModal}
                  containerName={selectedContainer.containerName}
                  rootFolderPath={folderPath}
                  sendPathToParent={updateFolderValue}
                  showInput={false}
                  numberOfDisabledInPath={0}
                />
              </Tooltip>
            </Col>
          </Row>

          <Row gutter={10}>
            <Col span={4} className="textOnPageColumn" style={{}}></Col>
            <Col span={8}>
              <div className="hintMsg" style={{ fontSize: "10px" }}>
                Provide file name or folder. The "*" sign represents any
                character
              </div>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col span={4} className="textOnPageColumn"></Col>
            <Col span={8}>
              <Space>
                <Form.Item>
                  <Tooltip
                    title={disabled ? "Provide file name or folder" : ""}
                  >
                    <Button
                      className="searchButton"
                      loading={loading}
                      type="primary"
                      htmlType="submit"
                      disabled={disabled}
                    >
                      Search
                    </Button>
                  </Tooltip>
                </Form.Item>
              </Space>
            </Col>
          </Row>
        </Col>
      </div>
    </Form>
  );
};
